<div class="d-my-wellness">
	<div class="d-title-holder">
		<h2 [translate]="'dashboard.wellness-panel.title'">My Health Snapshot</h2>
		<span>
			<a
				[routerLink]="['/wellness/my/health']"
				*ngIf="isMatchedMember"
				appEheAnalytics
				[data]="{
					pageUrl: '/dashboard',
					redirectedTo: '/wellness/my/health',
					componentName: 'wellness-panel',
					id: 'Dashboard wellness panel health snapshot',
					placement: 'Dashboard wellness panel'
				}">
				<i class="fa fa-angle-right"></i>
			</a>
		</span>
	</div>
	<div class="d-my-wellness-content">
		<div class="d-my-wellness-tab">
			<ul *ngIf="isHealthDataAvailable">
				<li
					*ngFor="let attribute of attributesList; let i = index"
					(mouseenter)="mouseEnter()"
					(mouseleave)="mouseLeave()">
					<a [class.active]="attributesList[0] === attribute" (click)="ArrayShuffle(i)">{{ attribute }}</a>
				</li>
			</ul>
			<div class="d-my-wellness-tab-content" *ngIf="isHealthDataAvailable">
				<div class="info">
					<p *ngIf="chartData !== null">UPDATED: {{ chartData.attributeUpdatedDate }}</p>
				</div>
				<div class="d-chart-area" *ngIf="chartData !== null">
					<ng-container *ngIf="chartData !== null">
						<ng-container [ngSwitch]="chartData.chartType">
							<div *ngSwitchCase="'text'" class="vertical-center">
								<p [style.color]="chartData.pointerColor">{{ chartData.attributeValue }}</p>
							</div>
							<app-gauge *ngSwitchCase="'gauge'" [chartData]="chartData"></app-gauge>
							<app-progress-bar *ngSwitchDefault [chartData]="chartData"></app-progress-bar>
						</ng-container>
					</ng-container>
				</div>
			</div>
			<div
				class="d-my-wellness-tab-content-data no-results-block"
				*ngIf="
					!isHealthDataAvailable &&
					(panelStatus?.wellnessPanel === 'NON_MATCHED' ||
						panelStatus?.wellnessPanel === 'NO_SCHEDULED_PE' ||
						panelStatus?.wellnessPanel === 'UPCOMING_PE' ||
						attributesList.length === 0)
				">
				<p [translate]="'dashboard.wellness-panel.key-indications.title'">
					After you complete your Health Assessment and EHE exam, key health indicators will be displayed here.
				</p>
				<button
					class="button"
					mat-stroked-button
					*ngIf="panelStatus?.wellnessPanel === 'NO_SCHEDULED_PE'"
					[routerLink]="['/scheduling/create/appointment']"
					appEheAnalytics
					[data]="{
						pageUrl: '/dashboard',
						redirectedTo: '/scheduling/create/appointment',
						componentName: 'wellness-panel',
						id: 'Dashboard wellness panel schedule exam',
						placement: 'Dashboard wellness panel'
					}">
					<span [translate]="'dashboard.wellness-panel.schedule-exam-button'">SCHEDULE AN EXAM</span>
				</button>
			</div>
		</div>
	</div>
</div>
